import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { ThemeProvider, createTheme } from "@mui/material/styles";

import { AppProvider } from "./context/AppContext";
import { LanguageProvider } from "./context/LanguageContext";
import LoginScreen from "./components/LoginScreen";
import ResetPassword from "./components/ResetPassword";
import EmailAuthenticationConfirm from "./components/EmailAuthenticationConfirm";
import DashboardLayout from "./components/DashboardLayout";
import AccountSettings from "./components/screens/AccountSettings";
import Overview from "./components/screens/Overview";
import Payments from "./components/screens/Payments";
import Wallets from "./components/screens/Wallets";
import Transactions from "./components/screens/Transactions";
import SupportTickets from "./components/screens/SupportTickets";
import Exchange from "./components/screens/Exchange";
import Stake from "./components/screens/StakePage";
import SafetyGuide from "./components/screens/SafetyGuide";

import "./assets/style/Styles.css"

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#6366f1",
    },
    background: {
      default: "#0f1924",
      paper: "#1c2532",
    },
  },
});

const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem("accessToken"); // Проверяем наличие токена
  if (!token) {
    // Если токена нет, перенаправляем на страницу входа
    return <Navigate to="/" replace />;
  }
  return children; // Если токен есть, показываем запрошенную страницу
};

function App() {  
  return (
    <ThemeProvider theme={darkTheme}>
      <LanguageProvider>
        <AppProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LoginScreen />} />
              {/* Public auth routes for password reset */}
              <Route path="/auth/reset-password" element={<ResetPassword />} />
              <Route path="/auth/email-authentication/confirm" element={<EmailAuthenticationConfirm />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/password/reset" element={<ResetPassword />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Overview />} />
                <Route path="overview" element={<Overview />} />
                <Route path="account-settings" element={<AccountSettings />} />
                <Route path="payments" element={<Payments />} />
                <Route path="wallets" element={<Wallets />} />
                <Route path="transactions" element={<Transactions />} />
                <Route path="support-tickets" element={<SupportTickets />} />
                <Route path="safety-guide" element={<SafetyGuide />} />
                <Route path="exchange" element={<Exchange />} />
                <Route path="stake" element={<Stake />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AppProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
